module.exports = __webpack_public_path__ + "912104c6a99131aaa4bfca8a8b253b88.svg";